import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './styles/globals.css'
import './styles/components.css'
import './shared/i18n'
import App from './app/App.tsx'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'


const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID?.trim() ?? ''

const AppWithProviders = () => {
  if (!googleClientId) {
    return <App />
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithProviders />
    <Analytics />
    <SpeedInsights />
  </StrictMode>
)
